import { API_CONFIG } from '../brands/default/config';
import axios from '../components/_generic/axiosSplunk/axiosSplunk';
import { getAppPlatform } from './device';

const adminFeeService = {};

adminFeeService.getAdminFee = async (dealId, product) => {
  if (!dealId) {
    return 0;
  }

  const data = {
    paymentViewRequest: {
      dealProducts: [
        {
          dealVoucherProductId: product.dealVoucherProductId,
          payDeposit: Boolean(product.payDeposit),
          quantity: product.quantity,
        },
      ],
    },
  };

  try {
    const response = await axios(
      `${process.env.NEXT_PUBLIC_LEGACY_API}/checkout/view/${dealId}?deliveryOptions=true`,
      {
        cache: false,
        data,
        headers: {
          'app-platform': getAppPlatform(),
          brand: API_CONFIG.BRAND_HEADER,
          'country-code': process.env.NEXT_PUBLIC_COUNTRY_CODE || 'gb',
          'sub-brand': API_CONFIG.SUB_BRAND,
          webapp: true,
        },
        method: 'POST',
      },
    );
    if (response) {
      const item =
        response.data.data.apiUserDealInfoList[0].apiDealProductsVO
          .theDealProducts[0];
      item.totalAmount = item.price * item.quantity + item.totalAdminFee;

      return item;
    }

    return 0;
  } catch {
    return 0;
  }
};

export default adminFeeService;
